import { pick } from '@ipfabric/utils/utils/pick';
import {
  type DiscoverySettingsObject,
  type SettingsData,
  discoverySettingsAttributes,
} from '../model/DiscoverySettingsObject';

export const pickDiscoverySettingsFromGlobalSettings = (
  data: SettingsData,
): DiscoverySettingsObject => pick(discoverySettingsAttributes)(data);
